import { dashboardRoutes } from './dashboard'
import { settingRouters } from './settings'
import { accountRouters } from './account'
import Permissions from '../permissions'
import { administrationRouters } from '@/routers/administrations'
import { teamRouters } from '@/routers/team'

export const primaryRouter = {
  path: '/admin',
  name: 'primary',
  component: () => import('@/layouts/Primary'),
  redirect: '/admin/dashboard',
  meta: {
    permissions: [Permissions.backend.manage]
  },
  children: [
    dashboardRoutes,
    administrationRouters,
    settingRouters,
    accountRouters,
    teamRouters
  ]
}
